// Sales Incentives helpers for the POS (display only).

const MODULE_CODES = ['module_not_enabled', 'module_read_only'];
export const PRODUCT_SET_RECHECK_MS = 5 * 60 * 1000;

// The API answers 403 with one of these codes when the module is off or was revoked.
export const isIncentiveModuleError = (error) => error?.status === 403 && MODULE_CODES.includes(error?.data?.code);

// Lines that would earn nobody: an incentive product with no line salesperson, on a bill with no salesperson
// (credit = line salesperson, else bill salesperson).
export function untaggedIncentiveLineCount(lines, productSet, billSalesperson) {
  if (billSalesperson || !productSet || productSet.size === 0) return 0;
  return (lines || []).filter((l) => productSet.has(l.product_id) && !l.salesperson_id).length;
}

// Never checked → check now; otherwise at most every 5 minutes.
export const shouldRecheckProductSet = (checkedAt, now = Date.now()) => !checkedAt || now - checkedAt >= PRODUCT_SET_RECHECK_MS;
